export const TransactionCategories = {
  en: {
    'Revenue Categories': 'Revenue Categories',
    'Expense Categories': 'Expense Categories',
    'Create Category': 'Create Category',
    'No categories': 'No categories',
    Code: 'Code',
    'Business Direction': 'Business Direction',
  },
  uk: {
    'Revenue Categories': 'Категорії надходжень',
    'Expense Categories': 'Категорії витрат',
    'Create Category': 'Створити категорію',
    'No categories': 'Немає категорій',
    Code: 'Код',
    'Business Direction': 'Напрямок діяльності',
  },
};

export const TransactionCategoryForm = {
  en: {
    ...TransactionCategories.en,
    'New Revenue Category': 'New Revenue Category',
    'Create Revenue Category': 'Create Revenue Category',
    'Edit Revenue Category': 'Edit Revenue Category',
    'Update Revenue Category': 'Update Revenue Category',
    'New Expense Category': 'New Expense Category',
    'Create Expense Category': 'Create Expense Category',
    'Edit Expense Category': 'Edit Expense Category',
    'Update Expense Category': 'Update Expense Category',
    'Parent Category': 'Parent Category',
    'No parent (root)': 'No parent (root)',
    'Code Hint':
      'Lowercase latin letters, digits and underscores only. Auto-filled from the name.',
  },
  uk: {
    ...TransactionCategories.uk,
    'New Revenue Category': 'Нова категорія надходження',
    'Create Revenue Category': 'Створити категорію надходження',
    'Edit Revenue Category': 'Редагування категорії надходження',
    'Update Revenue Category': 'Оновити категорію надходження',
    'New Expense Category': 'Нова категорія витрат',
    'Create Expense Category': 'Створити категорію витрат',
    'Edit Expense Category': 'Редагування категорії витрат',
    'Update Expense Category': 'Оновити категорію витрат',
    'Parent Category': 'Батьківська категорія',
    'No parent (root)': 'Без батьківської (корінь)',
    'Code Hint':
      'Лише малі латинські літери, цифри та підкреслення. Заповнюється з назви автоматично.',
  },
};
